// extracted by mini-css-extract-plugin
module.exports = {"Paper":"result_Paper__1bIc7","HomeBtn":"result_HomeBtn__1EiSM","Link":"result_Link__WK5Ci"};